import table2excel from 'js-table2excel'




export function ExportExcel(columns,data,excelName){
      // var columns = []
      // columnKeys.forEach((element,i) => {
      //   columns.push( {
      //     title: element,
      //     key: i+"",
      //     type: 'text'
      //   },)
      // });
      // // var data = [{"name":"aaaa"}]
      // var data = []
      // datas.forEach(eachD=>{
      //   var tempData = {}
      //   columnKeys.forEach((_,i) => {
      //     tempData[""+i] = eachD[i]
      //   })
      //   data.push(tempData)
      // })
      // console.log("要导出的数据是")
      // console.log(columns)
      // console.log(data)
      if(!excelName) excelName = `晓风Execl表.xlsx`
      table2excel(columns, data, excelName)
}